// utils/calculateMetrics1.js
export function calculateMetrics1(data) {
  const metrics = {};

  // Vaping
  metrics.ANYTOB30D = data.ANYTOB30D || 0;
  if (data.VAP30D > 9) {
    metrics.VAP30D = data.VAP30D;
    metrics.show_vape_comparision = 1;
  } else if (data.VAP30D > 0) {
    metrics.VAP30D = data.VAP30D;
    metrics.show_vape_comparision = 0;
  } else {
    metrics.VAP30D = 0;
    metrics.show_vape_comparision = 0;
  }

  // Marijuana
  if (data.MJ30D > 4) {
    metrics.MJ30D = data.MJ30D;
    metrics.show_mj_comparision = 1;
  } else if (data.MJ30D > 0) {
    metrics.MJ30D = data.MJ30D;
    metrics.show_mj_comparision = 0;
  } else {
    metrics.MJ30D = 0;
    metrics.show_mj_comparision = 0;
  }

  // Alcohol days
  if (data.ALC30D >= 4 && data.ALC30D <= 7) {
    metrics.ALC30D = data.ALC30D;
    metrics.show_alc_comparision = 1;
    metrics.show_drinker_pop_avg = 0;
  } else if (data.ALC30D > 7) {
    metrics.ALC30D = data.ALC30D;
    metrics.show_alc_comparision = 1;
    metrics.show_drinker_pop_avg = 1;
  } else if (data.ALC30D > 0) {
    metrics.ALC30D = data.ALC30D;
    metrics.show_alc_comparision = 0;
    metrics.show_drinker_pop_avg = 0;
  } else {
    metrics.ALC30D = 0;
    metrics.show_alc_comparision = 0;
    metrics.show_drinker_pop_avg = 0;
  }

  // Drinks Quantity (THRIVE1)
  if (data.THRIVE1 > 3.5) {
    metrics.ALOCHOL_QUANTITY = data.THRIVE1;
    metrics.show_alcohol_quantity_comparision = 1;
    metrics.show_drinker_pop_avg_alcohol_quantity = 1;
  } else if (data.THRIVE1 > 0) {
    metrics.ALOCHOL_QUANTITY = data.THRIVE1;
    metrics.show_alcohol_quantity_comparision = 0;
    metrics.show_drinker_pop_avg_alcohol_quantity = 0;
  } else {
    metrics.ALOCHOL_QUANTITY = 0;
    metrics.show_alcohol_quantity_comparision = 0;
    metrics.show_drinker_pop_avg_alcohol_quantity = 0;
  }

  // Binge
  if (data.BINGE530D >= 4) {
    metrics.BINGE530D = data.BINGE530D;
    metrics.show_binge_comparision = 1;
    metrics.show_drinker_pop_avg_binge = 1;
  } else if (data.BINGE530D > 0) {
    metrics.BINGE530D = data.BINGE530D;
    metrics.show_binge_comparision = 0;
    metrics.show_drinker_pop_avg_binge = 0;
  } else {
    metrics.BINGE530D = 0;
    metrics.show_binge_comparision = 0;
    metrics.show_drinker_pop_avg_binge = 0;
  }

    // BAC Calculations
  const heaviest_no_standard_drinks = data['4WKSLARGESTSD'] || 0;
  const gender = data.gender_assigned_at_birth;
  const sex_constant = gender === 'M' ? 7.5 : 9;
  const largest_no_of_drinks_per_hour = data.LARGESTDRINKSBYHOUR || 0;
  const no_of_drinks_per_hour = data.DRINKSBYHOUR || 0;
  const weight = data.BACWEIGHT || 0;

  let HEAVIEST_BAC =
    ((heaviest_no_standard_drinks / 2) * (sex_constant / weight)) -
    (largest_no_of_drinks_per_hour * 0.016);
  let BAC =
    (((data.THRIVE1 || 0) / 2) * (sex_constant / weight)) -
    (no_of_drinks_per_hour * 0.016);

  HEAVIEST_BAC = Math.min(Math.max(HEAVIEST_BAC, 0), 0.4);
  BAC = Math.min(Math.max(BAC, 0), 0.4);

  metrics.HEAVIEST_BAC = HEAVIEST_BAC;
  metrics.BAC = BAC;
  metrics.show_bac_comparision = BAC > 0;

  // --------------------
  // AUDIT Score (official scoring, 0–4 each question)
  // --------------------
  let audit_score = 0;

  // Q1 (frequency of drinking) — use directly
  const q1 = Number(data.AUDIT1);
audit_score += (q1 >= 0 && q1 <= 4) ? q1 : 0;


  // Q2 (typical drinks) needs mapping: 0–2=0, 3–4=1, 5–6=2, 7–9=3, 10+=4
  function scoreAUDIT_Q2(val) {
    const n = Number(val) || 0;
    if (n <= 2) return 0;
    if (n <= 4) return 1;
    if (n <= 6) return 2;
    if (n <= 9) return 3;
    return 4;
  }
  if (data.THRIVE1 !== undefined) audit_score += scoreAUDIT_Q2(data.THRIVE1);

  // Q3–Q10: frequency/yes-no questions → already coded 0–4
  const auditKeys = [
    'AUDIT2',   // Q3
    'THRIVE2',  // Q4
    'THRIVE3',  // Q5
    'THRIVE4',  // Q6
    'THRIVE5',  // Q7
    'THRIVE6',  // Q8
    'THRIVE7',  // Q9
    'THRIVE8',  // Q10
  ];
  auditKeys.forEach(k => {
  const val = Number(data[k]);
  audit_score += (val >= 0 && val <= 4) ? val : 0;
});


  metrics.audit_score = audit_score;

 
  return metrics;
}
